<div class="not-permitted user-select-none">
  <div class="text-center align-items-center denied-text">
    You do not have permission to access this screen
  </div>
</div>
